var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{ref:"el",tag:"component",on:{"mouseover":_vm.onMouseOver,"mouseout":function($event){$event.stopPropagation();return _vm.onMouseOut($event)},"click":_vm.onClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }